import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { Link } from 'react-router-dom';

class Topnav extends Component {

  handleLogoutClick(e) {
    e.preventDefault();
    this.props.store.logout();
  }

  render() {    
    return (  
      <span>
      
      <div className="container-fluid border-bottom">
        <div className="container">
          <header className="py-3">         
            <div className="row flex-nowrap justify-content-between align-items-center">
              <div className="col-4 d-block d-sm-none">
                <img
                  alt="" 
                  src="https://my.kabbalah.com/ticket-widget/media/logo-small.png"
                  className=""
                  width="35px"
                />                
              </div>             
              <div className="col-4 pt-1">
                <Link className="text-dark" to="/">My Courses</Link>
              </div>
              <div className="col-4 text-center d-none d-sm-block">
                <img
                  alt="" 
                  src="https://my.kabbalah.com/ticket-widget/media/logo.svg"
                  className=""
                  width="164px"
                />                
              </div>
              <div className="col-4 d-flex justify-content-end align-items-center">
                <span className="d-none d-lg-block">
                  {this.props.store.emailClaim}
                  &nbsp;&nbsp;
                </span>
                <button 
                  className="btn btn-sm btn-outline-secondary" 
                  onClick={this.handleLogoutClick.bind(this)}>Logout
                </button>
              </div>
            </div>
          </header>   
        </div>   
      </div>
      
      {/*
      <nav className="navbar navbar-expand navbar-light bg-white border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-4">
              <a className="navbar-brand" href="#">
                <img
                  alt="" 
                  src="https://kabbalah.com/content/dam/kabbalah/logos/TKC_Monogram_Large_RGB.png"
                  className="rounded float-right image-fluid"
                  width="43px"
                />
              </a>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample03" aria-controls="navbarsExample03" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse" id="navbarsExample03">
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item active">
                    <a className="nav-link" href="#">Home <span className="sr-only">(current)</span></a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">Link</a>
                  </li>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="https://example.com" id="dropdown03" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Dropdown</a>
                    <div className="dropdown-menu" aria-labelledby="dropdown03">
                      <a className="dropdown-item" href="#">Action</a>
                      <a className="dropdown-item" href="#">Another action</a>
                      <a className="dropdown-item" href="#">Something else here</a>
                    </div>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </nav>*/}  

      </span>
    );
  }
}

export default inject('store')(observer(Topnav));



// WEBPACK FOOTER //
// ./src/components/Navbar.js